<template>
    <div class="form-add-client">
        <div class="form-add-client__title">
            Добавление клиента
        </div>
        <div class="form-add-client__input">
            <dropdown
                    title="Клиент"
                    :items="values"
                    :selectedItems="client_id ? [client_id] : []"
                    :isManyItems="false"
                    :width="'220px'"
                    :height="'44px'"
                    :prompt="'Выберите клиента'"
                    @onChange="onChangeClient($event)"
            />
        </div>
        <div class="form-add-client__btn-container">
            <button class="form-add-client__button" @click="onClickCancel">Отмена</button>
            <button
                class="form-add-client__button form-add-client__action-button"
                v-if="client_id"
                type="submit"
                @click="onClickSubmit"
            >
                Добавить
            </button>
        </div>
    </div>
</template>

<script>
import Dropdown from "../Base/Dropdown";

export default {
    name: 'FormAddClientList',
    components: {
        Dropdown
    },
    /**
     * входные данные компонента
     * @property {string} client_id - id клиента
     * @property {Object} values - клиенты
     */
    props: {
        client_id: {
            type: String,
            default: null
        },
        values:{
            type: Object,
            default: () => ({})
        }
    },
    methods: {
        /**
         * событие изменения значения чекбокса
         */
        onChangeClient(data){
            this.client_id = data[0];
        },
        /**
         * событие отправки имени новой группы
         */
        onClickSubmit() {
            this.$emit('submitForm', this.client_id.slice(1));
        },
        onClickCancel(){
            this.$emit('cancelForm');
        }
    }
}
</script>

<style lang="scss" scoped>
    .form-add-client {
        height: 400px;
    }
    .form-add-client__title {
        text-align: center;
        font-size: 20px;
        margin: 20px 20px 20px 20px;
    }
    .form-add-client__input {
        text-align: center;
        margin: 20px 20px 20px 20px;
    }
    .form-add-client__input input {
        width: 100%;
    }
    .form-add-client__btn-container {
        text-align: end;
        margin: 20px 20px 20px 20px;
        bottom: 10px;
        right: 10px;
        position: absolute;
    }
    .form-add-client__button{
        cursor: pointer;
        pointer-events: auto;
        height: 32px;
        width: min-content;
        padding: 4px 14px;
        border-radius: 100px;
        transition: 0.3s;
        border: 1px solid transparent;
        outline: none;
    }
    .form-add-client__action-button{
        margin-left: 5px;
        color: #000;
        background: #fe1060;
    }
</style>